import { createFileRoute } from '@tanstack/react-router';
import { ClinicalSettingsPage } from '@/features/clinical/pages/settings-page';

export const Route = createFileRoute('/_app/settings/clinical')({ component: ClinicalSettingsPage });
